// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MhMt","col":"styles_col__LS5sn","actions":"styles_actions__kg6O0","conflict":"styles_conflict__1UGUZ"};